import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PayDTO } from '../../dtos/dto';
import { IBookingGets, IBookingSetStatus } from '../../interfaces/booking.interface';
import { IPaginationGet } from '../../interfaces/interface';
import { BookingServiceDTO } from './booking-service.dto';
import { IBookingServiceCreate } from './booking-service.interface';

@Injectable({
  providedIn: 'root',
})
export class BookingServiceApi {
  private readonly apiUrl: string = environment.apiUrl;

  constructor(private readonly http: HttpClient) {}

  create(booking: IBookingServiceCreate): Observable<BookingServiceDTO[]> {
    return this.http.post<BookingServiceDTO[]>(this.apiUrl + `/service/booking`, booking);
  }

  gets(booking: IBookingGets): Observable<IPaginationGet<BookingServiceDTO[]>> {
    return this.http.post<IPaginationGet<BookingServiceDTO[]>>(this.apiUrl + `/service/booking/search`, booking);
  }

  setStatus(id: number, status: IBookingSetStatus): Observable<BookingServiceDTO> {
    return this.http.post<BookingServiceDTO>(this.apiUrl + `/service/booking/${id}/status`, status);
  }

  pay(id: number): Observable<PayDTO> {
    return this.http.get<PayDTO>(this.apiUrl + `/service/booking/${id}/pay`);
  }
}
